import React from 'react';
import type CurrentUser from '../Models/CurrentUserModel';

export type UserContextProps = {
    currentUser: CurrentUser | null,
    setCurrentUser: (currentUser: CurrentUser | null) => void,
    lastActivity: Date | null,
    setLastActivity: (date: Date | null) => void,
    hashedPin: string | null,
    setHashedPin: (value: string | null) => void,
};

const UserContext: React.Context<UserContextProps> = React.createContext<UserContextProps>({
    currentUser: null,
    setCurrentUser: () => {},
    lastActivity: null,
    setLastActivity: () => {},
    hashedPin: null,
    setHashedPin: () => {},
});

export default UserContext;